import PropTypes from "prop-types"
import classNames from "classnames"
import { ExpandMore } from "@mui/icons-material"
import "./style.scss"

export default function DropdownIcon({ isOpen, className, fontSize = "small", ...props }) {
  return (
    <ExpandMore
      fontSize={fontSize}
      className={classNames("dropdown-icon", { "dropdown-icon--open": isOpen }, className)}
      {...props}
    />
  )
}

DropdownIcon.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  fontSize: PropTypes.oneOf(["inherit", "large", "medium", "small"]),
}
